import React from 'react';
import './CommericalDetails.css';
import LawnPackage from './LawnPackage';

const commercialServices = [
  {
    title: 'Mowing',
    description:
      'We provide consistent, even cuts that support healthy lawn growth and keep your property looking sharp. Routine mowing keeps things clean and manageable throughout the year.',
  },
  {
    title: 'Edging & Trimming',
    description:
      'We edge along sidewalks, driveways, and garden beds to create clean, defined lines. Shrubs and bushes are trimmed to maintain their shape and prevent overgrowth.',
  },
  {
    title: 'Blowing',
    description:
      'We clear away grass clippings, leaves, and debris from all areas of your property. Walkways, driveways, and beds are left clean after every visit.',
  },
  {
    title: 'Pruning',
    description:
      'We prune trees and large plants to support healthy growth, improve airflow, and reduce the risk of disease. Proper pruning also helps trees keep a balanced, natural shape.',
  },
  {
    title: 'Flower Bed Care & Weed Control',
    description:
      'We maintain flower beds by removing weeds, loosening soil, and checking plant health. Your beds stay neat, and your plants get the space and support they need.',
  },
  {
    title: 'Fertilizer Applications',
    description:
      'We apply the right nutrients at the right time to keep grass, plants, and trees growing strong. Healthy, well-fed landscapes hold up better through changing seasons.',
  },
];

export default function CommercialDetails() {
  return (
    <section className="CommercialDetails">
      <div className="CommercialDetails__container">
        <header className="CommercialDetails__main-header">
          <h2 className="CommercialDetails__main-title">
            Commercial Landscape Maintenance Services
          </h2>
             <div className="rl-title-underline"></div>
          <p className="CommercialDetails__main-description">
            Primed Landscaping provides expert commercial landscape maintenance tailored to your property. Our team works with consistency and care to keep your outdoor spaces neat, healthy, and professional through every season.
          </p>
        </header>

        <div className="CommercialDetails__services">
          {commercialServices.map((service, idx) => (
            <article key={idx} className="CommercialDetails__service">
              <div className="CommercialDetails__service-content">
                <h2 className="CommercialDetails__service-title">{service.title}</h2>
                <p className="CommercialDetails__service-description">{service.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>

      <LawnPackage />
    </section>
  );
}
